<div class="periodic-review-table__column-picker">
  <label class="custom-mat-select_table-column-label">{{ 'general.table.label.column' | translate }}:</label>
  <mat-form-field class="custom-mat-form-field custom-mat-select_table-column-picker" floatLabel="never">
    <mat-label>{{ 'general.table.label.select_column' | translate }}</mat-label>
    <img matSuffix class="custom-mat-select_table-column-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select [(ngModel)]="isActiveTableTab" [(value)]="isActiveTableTab">
      <mat-option value="context">{{ 'general.table.label.status' | translate }}</mat-option>
      <mat-option value="riskRating">{{ 'general.table.label.risk_rating' | translate }}</mat-option>
      <mat-option value="riskReportCreatedAt">{{ 'general.table.label.report_created' | translate }}</mat-option>
      <mat-option value="actions">{{ 'general.table.label.actions' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="periodic-review-table__search">
  <mat-form-field class="custom-mat-form-field periodic-review-table__search-mat-field" floatLabel="never">
    <input matInput placeholder="{{ 'general.search.label.search_by_name' | translate }}" (keyup.enter)="applyNameFilter($event.target.value)" [(ngModel)]="filterPeriodicReviewName">
    <img matSuffix class="themified-white-icon periodic-review-table__search-icon" [ngClass]="{'periodic-review-table__search-disabled': !filterPeriodicReviewName}" src="/assets/icons/magnifying-glass-icon.png" (click)="getPeriodicReviewTableData()" />
  </mat-form-field>
</div>
<div class="periodic-review-table__container">
  <artemis-loading-spinner *ngIf="isLoading"></artemis-loading-spinner>
  <div class="periodic-review-table__wrapper">
    <table class="custom-mat-table periodic-review-table custom-mat-table_first-column" mat-table matSort [dataSource]="periodicReviewDataSource" (matSortChange)="tableSortChangeHandler($event)">

      <ng-container matColumnDef="name">
        <th class="periodic-review-table__column-name" mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.name' | translate }} </th>
        <td class="periodic-review-table__column-name" mat-cell *matCellDef="let periodicReview" [title]="periodicReview.name">
          <a class="link" [routerLink]="['/customers/' + periodicReview.id]">
            {{periodicReview.name}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="risk_rating">
        <th class="periodic-review-table__column-rating" mat-header-cell *matHeaderCellDef mat-sort-header
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'riskRating'}">
          {{ 'general.table.label.risk_rating' | translate }}
        </th>
        <td class="periodic-review-table__column-rating" mat-cell *matCellDef="let periodicReview" [title]="periodicReview.riskRating"
            [ngClass]="{'periodic-review-table__cell_accent': periodicReview.riskRating === 'MEDIUM',
                        'periodic-review-table__cell_green': periodicReview.riskRating === 'LOW',
                        'periodic-review-table__cell_alert': periodicReview.riskRating === 'HIGH',
                        'mat-cell__column-active': isActiveTableTab === 'riskRating'}">
          <span>{{periodicReview.riskRating}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="risk_report_created_at">
        <th class="periodic-review-table__column-created-at" mat-header-cell *matHeaderCellDef mat-sort-header
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'riskReportCreatedAt'}">
          {{ 'general.table.label.report_created' | translate }}
        </th>
        <td class="periodic-review-table__column-created-at" mat-cell *matCellDef="let periodicReview"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'riskReportCreatedAt'}"
            [title]="periodicReview.riskReportCreatedAt ? (periodicReview.riskReportCreatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') : periodicReview.riskReportCreatedAt">
          {{periodicReview.riskReportCreatedAt ? (periodicReview.riskReportCreatedAt | date:'dd/MM/yyyy \'at\' h:mm:ss a') : periodicReview.riskReportCreatedAt}}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th class="periodic-review-table__column-actions" mat-header-cell *matHeaderCellDef
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'actions'}">
          {{ 'general.table.label.actions' | translate }}
        </th>
        <td class="periodic-review-table__column-actions" mat-cell *matCellDef="let periodicReview"
            [ngClass]="{'mat-cell__column-active': isActiveTableTab === 'actions'}">
          <div class="periodic-review-table__links-container">
            <a mat-icon-button class="link custom-mat-icon-button periodic-review-table__link" [routerLink]="['/customers/' + periodicReview.id + '/edit/']" title="Edit Customer">
              <img class="themified-white-icon periodic-review-table__link-icon" src="/assets/icons/edit-icon.png"/>
            </a>
            <a mat-icon-button class="link custom-mat-icon-button periodic-review-table__link" [routerLink]="['/customers/' + periodicReview.id + '/screening/']" title="Screening">
              <img class="themified-white-icon periodic-review-table__link-icon" src="/assets/icons/screening-icon.png"/>
            </a>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div class="table-empty" *ngIf="periodicReviewResults && periodicReviewResults.length === 0">
    {{ 'dashboard.task_list.message.no_customer' | translate }}
  </div>
  <mat-paginator #paginator class="custom-mat-paginator" 
  (page)="tablePaginationChangeHandler($event)" 
  showFirstLastButtons 
  [pageSizeOptions]="pageSizeOptions" 
  [pageSize]="preferredPeriodicReviewTablePageSize" 
  [length]="periodicReviewDataSourceLength | async">
  </mat-paginator>
</div>
